module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_stills_tetra_200_cepita_nar.8004f313.png";